export default __webpack_public_path__ + "zapway-mais.svg?8966cdb6b90e842181c8e23b54d795c6";